module.exports = __webpack_public_path__ + "img/m2g_why_02.79c2b1e6.png";